import React from 'react';
import { Grid } from '@chakra-ui/react';
import { MenuButton } from '../menu-button/menu-button';
import { MenuItem } from '../menu-button/menu-item';
import { CMXIcon } from '@codametrix/ui-components';

// Define types for the props
export type MenuOptionProps = {
  label: string;
  onClick: (ev: React.MouseEvent) => void;
};

export type MenuListProps = {
  options: MenuOptionProps[];
};

// Component to render action menu
export const MenuList: React.FC<MenuListProps> = ({ options }) => {
  const icon = (
    <CMXIcon
      svgIconName="BiomeVerticalMenu"
      svgIconClass="menu-list-icon"
      svgIconSize="16"
    />
  );

  return (
    //@ts-ignore
    <Grid className="menu-list">
      <MenuButton icon={icon}>
        {options.map((option, idx) => (
          <MenuItem key={idx} onSelect={option.onClick}>
            {option.label}
          </MenuItem>
        ))}
      </MenuButton>
    </Grid>
  );
};
